export const brandingSettings = {
  common: {
    logoDimensions: {
      width: 284,
      height: 64
    },
    allowedMimeType: ['image/png', 'image/svg+xml']
  }
};
